import { improvementsConditions } from './conditions'
import { improvementsScenarios } from './steps'
import { improvementsTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const improvementsOnboarding: IOnboardingModule = {
  scenarios: improvementsScenarios,
  texts: improvementsTexts,
  conditions: improvementsConditions,
}
